import { lazy } from 'react';
const pathMap: Record<ComponentName, any> = {
    'canopy-table': lazy(
        () =>
            import('../canopy-ui-components/components/CanopyTable/CanopyTable')
    ),
    login: lazy(
        () => import('../canopy-ui-components/components/LoginPage/LoginPage')
    ),
    'allocations-donut-chart': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Allocations/AllocationsDonutChart'
            )
    ),
    'allocations-map-chart': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Allocations/AllocationsMapChart'
            )
    ),
    'page-header': lazy(
        () => import('../canopy-ui-components/components/PageHeader/PageHeader')
    ),
    'allocations-page-header': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Allocations/AllocationsPageHeader'
            )
    ),
    'chart-data-table': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Allocations/ChartDataTable'
            )
    ),
    'allocations-bar-chart': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Allocations/AllocationsBarChart'
            )
    ),
    'allocations-legend': lazy(
        () => import('../canopy-ui-components/components/Allocations/Legend')
    ),
    'client-modal': lazy(() => import('../components/portfolio/ClientsModal')),
    'update-db-action': lazy(
        () => import('../components/ClientList/Actions/UpdateDBAction')
    ),

    'user-selection': lazy(
        () => import('../components/SuperAdmin/UserSelection')
    ),
    'movers-container': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Movers/MoversTileContainer'
            )
    ),
    'networth-stacked-chart': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Networth/NetworthStackedAreaChart'
            )
    ),
    'networth-page-header': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Networth/NetworthPageHeader'
            )
    ),
    'networth-chart-modifier': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Networth/NetworthChartModifier'
            )
    ),
    'excel-addin': lazy(() => import('../components/ExcelAddin/ExcelAddin')),
    'generate-reports': lazy(
        () =>
            import('../canopy-ui-components/components/Reports/GenerateReports')
    ),
    'report-status': lazy(
        () => import('../canopy-ui-components/components/Reports/ReportStatus')
    ),
    'cashflows-bar-chart': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Cashflows/CashflowsBarChart'
            )
    ),
    'exposure-reports-wrapper': lazy(
        () => import('../components/ExposureReports/ExposureReportsWrapper')
    ),
    'performance-comparator': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Performance/PerformanceComparator'
            )
    ),
    'performance-chart': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Performance/PerformanceChart'
            )
    ),
    'explaing-change-button': lazy(
        () =>
            import(
                '../canopy-ui-components/components/Performance/ExplainChangeButton'
            )
    ),
    'canopy-collapse': lazy(
        () =>
            import(
                '../canopy-ui-components/components/CanopyCollapse/CanopyCollapse'
            )
    ),
    'portfolio-status-footer': lazy(
        () => import('../components/portfolio/PortfolioStatus')
    ),
    'run-strategies-action': lazy(
        () =>
            import(
                '../components/ManageStrategies/Actions/ViewStrategiesActions'
            )
    ),
    'run-strategies-modal': lazy(
        () =>
            import('../components/ManageStrategies/Actions/RunStrategiesModal')
    ),
    'rule-based-strategy': lazy(
        () =>
            import(
                '../components/ManageStrategies/CreateStrategy/RuleBasedStrategy/RuleBasedStrategy'
            )
    ),
    'query-based-strategy': lazy(
        () =>
            import(
                '../components/ManageStrategies/CreateStrategy/QueryBasedStrategy/QueryBasedStrategy'
            )
    ),
    'template-based-strategy': lazy(
        () =>
            import(
                '../components/ManageStrategies/CreateStrategy/TemplateBasedStrategy/TemplateBasedStrategy'
            )
    ),
    'performance-action-bar': lazy(
        () =>
            import('../canopy-ui-components/components/Performance/ActionsBar')
    ),
    'view-strategies-table': lazy(
        () => import('../components/ManageStrategies/ViewStrategies')
    ),
    'view-strategies-transactions-modal': lazy(
        () =>
            import(
                '../components/ManageStrategies/Actions/ViewStrategyTransactionsModal'
            )
    ),
    'documents-storage-file-upload': lazy(
        () => import('../components/Upload/documents-storage/upload/Index')
    ),
    'statement-processing-file-upload': lazy(
        () => import('../components/Upload/statement-processing/upload/Index')
    ),
    'edit-file-modal': lazy(
        () =>
            import(
                '../components/Upload/documents-storage/actions/EditFileDetailsModal'
            )
    ),
    'documents-action': lazy(
        () =>
            import(
                '../components/Upload/documents-storage/actions/DocumentsAction'
            )
    ),
    'download-file-action': lazy(
        () =>
            import(
                '../components/Upload/documents-storage/actions/DownloadFileAction'
            )
    ),
    'edit-file-tags-action': lazy(
        () =>
            import(
                '../components/Upload/documents-storage/actions/EditFileDetailsAction'
            )
    ),
    'delete-file-action': lazy(
        () =>
            import(
                '../components/Upload/documents-storage/actions/DeleteFileAction'
            )
    ),
    'mappings-action': lazy(
        () => import('../components/AnalyticsMappings/actions/MappingsActions')
    ),
    'delete-mapping-action': lazy(
        () =>
            import(
                '../components/AnalyticsMappings/actions/DeleteMappingsAction'
            )
    ),
    'edit-mapping-action': lazy(
        () =>
            import(
                '../components/AnalyticsMappings/actions/EditMappingsActions'
            )
    ),
    'copy-mapping-action': lazy(
        () =>
            import(
                '../components/AnalyticsMappings/actions/CopyAndCreateAction'
            )
    ),
    'mapping-action-bar': lazy(
        () => import('../components/AnalyticsMappings/actions/ActionsBar')
    ),
    'documents-filters': lazy(
        () =>
            import(
                '../components/Upload/documents-storage/filters/SimpleFilters'
            )
    ),
    'holdings-filters': lazy(
        () => import('../components/Holdings/SimpleFilters')
    ),
    'view-strategies-filters': lazy(
        () => import('../components/ManageStrategies/Filters/SimpleFilters')
    ),
    'fee-report-filters': lazy(
        () => import('../components/FeeReport/Filters/SimpleFilters')
    ),
    'view-ticket-details': lazy(
        () => import('../components/FeeReport/Filters/SimpleFilters')
    ),
    'tableau-wrapper': lazy(
        () => import('../components/Tableau/TableauWrapper')
    ),
    'customer-workbook-wrapper': lazy(
        () => import('../components/Tableau/CustomerWorkbookWrapper')
    ),
    'delete-strategy-action': lazy(
        () =>
            import(
                '../components/ManageStrategies/Actions/DeleteStrategyAction'
            )
    ),
    'download-strategies-action': lazy(
        () =>
            import(
                '../components/ManageStrategies/Actions/DownloadStrategyAction'
            )
    ),
    'custom-downloader': lazy(
        () => import('../components/FeeReport/CustomDownloader')
    ),
    'data-management-file-upload': lazy(
        () => import('../components/Upload/data-management/upload')
    ),
    'template-selector': lazy(
        () =>
            import(
                '../components/Upload/data-management/download/TemplateSelector'
            )
    ),
    'user-preferences': lazy(
        () => import('../components/Preferences/Preferences')
    ),
    'menu-mapping-action-bar': lazy(
        () => import('../components/MenuMapping/ActionBar')
    ),
};

export default pathMap;
